"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
/**
 * *******************************
 * Functions
 * *******************************
 */
/**
 * Returns a label as a value that can be a code.
 * @example
 * toCode("Hello world"); // "hello_world"
 * toCode("this IS a bunch of values 1"); // "this_is_a_bunch_of_values_1"
 * @export
 * @param {string} label
 * @returns {string} that is code compatible.
 */
function toCode(label) {
    return (label || "")
        .split(/\s+/)
        .filter(function (s) { return s.trim() !== ""; })
        .map(function (s) { return s.toLowerCase(); })
        .join("_");
}
exports.toCode = toCode;
/**
 * Puts the label into a display
 *
 * @export
 * @param {string} label
 * @returns {string}
 */
function toDisplay(label) {
    return (label || "")
        .replace(/_/g, " ")
        .split(/\s+/)
        .filter(function (s) { return s.trim() !== ""; })
        .map(capitalize)
        .join(" ");
}
exports.toDisplay = toDisplay;
/**
 * Uppercases first character of string
 *
 * @export
 * @param {string} value
 * @returns {string}
 */
function capitalize(value) {
    if (_1.isNullOrUndefined(value)) {
        return "";
    }
    value = value.toLowerCase();
    return value.slice(0, 1).toUpperCase() + value.slice(1);
}
exports.capitalize = capitalize;
/**
 * Validates if the parameter is of type string and if it is null or whitespace
 *
 * @export
 * @param {any} value
 * @returns {boolean}
 */
function isStringAndEmpty(value) {
    return typeof value === 'string' && isNullOrWhitespace(value);
}
exports.isStringAndEmpty = isStringAndEmpty;
/**
 * Checks if a string is null or whitespace.
 *
 * @export
 * @param {string} value to check if the value is null or whitespace
 * @returns {boolean} true if it's null, undefined, empty or whitespace else false
 */
function isNullOrWhitespace(value) {
    var type = typeof value;
    if (type === 'boolean' || type === 'number') {
        value = value.toString();
    }
    return (value || "").trim() === "";
}
exports.isNullOrWhitespace = isNullOrWhitespace;
/**
 * Produces a date format
 * TODO : If this get's any bigger then use moment
 *
 * @export
 * @param {Date} date
 */
function toDayFormat(date) {
    if (_1.isNullOrUndefined(date)) {
        return null;
    }
    return date.getFullYear() + "-" + pad(date.getMonth() + 1, 2, '0') + "-" + pad(date.getDate(), 2, '0');
}
exports.toDayFormat = toDayFormat;
/**
 * Pads a string with a specified character to a desired length
 *
 * @export
 * @param {string | number} value
 * @param {number} length
 * @param {string | number} [character='0']
 * @param {CharacterPlacement} characterPlacement
 *  @returns {string}
 */
function pad(value, length, character, characterPlacement) {
    if (character === void 0) { character = '0'; }
    if (characterPlacement === void 0) { characterPlacement = 'prefix'; }
    if (_1.isNullOrUndefined(value)) {
        value = "";
    }
    if (_1.isNullOrUndefined(character)) {
        character = '0';
    }
    value = value.toString();
    character = character.toString();
    if (!length || length < 0) {
        return value;
    }
    while (value.length < length) {
        switch (characterPlacement) {
            case "suffix":
                value = "" + value + character;
                break;
            case "prefix":
            default:
                value = "" + character + value;
                break;
        }
    }
    return value;
}
exports.pad = pad;
//# sourceMappingURL=string.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys_utils/dist/string.js
// module id = 1252
// module chunks = 1